import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../../server-parameters'
import { yearsAgo } from '../../../../../utils/helpers'
import {
  validateName,
  validateDate,
  passportDigits,
  passportText,
  smartValidateString,
} from '../../../../../validate/validators'
import { Country, Lang } from '../../../../../types/common-types'
import { State } from '../../../../../state-actions-reducers'
import FileInput from '../../../../../shared/Inputs/FileInput/FileInput'

export default function UzbekistanForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      <div className="col-2 col-xs-12">
        {/* PASSPORT SERIES / NUMBER */}
        <TextInput
          testName={'passportNumber'}
          testErrorName={'error-passportNumber'}
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.passportNumber}
          onChange={passportNumber => {
            setValue('passportNumber', passportNumber, { shouldDirty: true })
          }}
          value={state.passportNumber}
          required
          valid={
            passportDigits(state.passportNumber) &&
            !errors.passportNumber
          }
          onBlur={() => setFocus('')}
          mask={undefined}
        />
      </div>
      <div className="col-8 col-xs-12">
        {/* PASSPORT ISSUED BY */}
        <TextInput
          testName={'passportIssuedBy'}
          testErrorName={'error-passportIssuedBy'}
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.issuedBy}
          onChange={passportIssuedBy =>
            setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
          }
          value={state.passportIssuedBy}
          required
          valid={
            state.passportIssuedBy.length > 0
              ? smartValidateString(state.passportIssuedBy) &&
                !errors.passportIssuedBy
              : !errors.passportIssuedBy
          }
          onBlur={() => setFocus('')}
        />
      </div>
      <div className="col-2 col-xs-12">
        {/* PASSPORT ISSUE DATE */}
        <DatePicker
          testName={'passportIAt'}
          testErrorName={'error-passportIAt'}
          disabled={!state.agreed}
          lang={lang}
          accountForm={accountForm}
          accountFormKey="passportIAt"
          onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
          value={state.passportIAt}
          required
          valid={!errors.passportIAt}
          onBlur={() => setFocus('')}
          curr={
            state.birthDate
              ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear() + 14
                  )
                )
              : new Date()
          }
          min={
            state.birthDate
              ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear() + 14
                  )
                )
              : new Date(new Date().setFullYear(new Date().getFullYear() - 67))
          }
          max={new Date()}
        />
      </div>
      <div className="col-2 col-xs-12">
        {/* PASSPORT EXPIRY DATE */}
        <DatePicker
          testName={'passportExpiryDate'}
          testErrorName={'error-passportExpiryDate'}
          disabled={!state.agreed}
          lang={lang}
          accountForm={accountForm}
          accountFormKey="passportExpiryDate"
          onChange={data =>
            setValue('passportExpiryDate', data, { shouldDirty: true })
          }
          value={state.passportExpiryDate}
          required
          valid={!errors.passportExpiryDate}
          onBlur={() => setFocus('')}
          min={new Date()}
          max={new Date(new Date().setFullYear(new Date().getFullYear() + 10))}
        />
      </div>
      <div className="col-4 col-xs-12">
        <FileInput
          testName={'F_Scan_Directors_Passport'}
          testErrorName={'error-F_Scan_Directors_Passport'}
          disabled={!state.agreed}
          lang={lang}
          url={UPLOADS_ENDPOINT}
          autorization={state.formId}
          target={state.documentsImages}
          content={accountForm.mainImageFile}
          
          onChange={data => {
            setValue('F_Scan_Directors_Passport', [...(getValues('F_Scan_Directors_Passport')||[]), data], { shouldDirty: true })
          }}
          value={
            state.F_Scan_Directors_Passport[
              state.F_Scan_Directors_Passport.length - 1
            ]
          }
          valid={!errors.F_Scan_Directors_Passport}
          documentType="Passport1"
          imageErrors={state.imageError}
        />
      </div>
      <div className="col-4 col-xs-12">
        <FileInput
          testName={'F_Scan_Directors_Passport_Address'}
          testErrorName={'error-F_Scan_Directors_Passport_Address'}
          disabled={!state.agreed}
          lang={lang}
          url={UPLOADS_ENDPOINT}
          autorization={state.formId}
          target={state.documentsImages}
          
          content={
            selectedCitizenship === 'Таджикистан' ||
            selectedCitizenship === 'Узбекистан'
              ? accountForm.addressImageFile
              : accountForm.vizaImageFile
          }
          
          onChange={data => {
            setValue('F_Scan_Directors_Passport_Address', [...(getValues('F_Scan_Directors_Passport_Address')||[]), data], { shouldDirty: true })
          }}
          value={
            state.F_Scan_Directors_Passport_Address[
              state.F_Scan_Directors_Passport_Address.length - 1
            ]
          }
          valid={!errors.F_Scan_Directors_Passport_Address}
          documentType="Passport2"
          imageErrors={state.imageError}
        />
      </div>
    </>
  )
}
